<template lang="pug">
  .sort-area
    .sort-area-inner
      span.count
        | 開業情報リスト
        | {{ Number(total).toLocaleString() }}件
      .sort-link
        select(v-model="order")
          option(v-for="option in options" :value="option.value") {{ option.text }}
      .sort-btn-wrapper
        a.open-search-button(@click="toggleSidebar") 検索条件
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        options: [
          { text: 'ソート順指定なし', value: '' },
          { text: 'リスト更新日時(降順)', value: 'updated_at:desc' },
          { text: 'リスト更新日時(昇順)', value: 'updated_at:asc' },
          { text: 'リスト追加日時(降順)', value: 'created_at:desc' },
          { text: 'リスト追加日時(昇順)', value: 'created_at:asc' },
        ],
      }
    },
    computed: {
      ...mapState({
        total: state => state.startingBusinessList.pagination.totalCount,
        order: state => state.searchStartingBusinessList.query.order,
      }),
      order: {
        get () {
          return this.$store.state.searchStartingBusinessList.query.order
        },
        set (value) {
          this.$store.commit('searchStartingBusinessList/order', value)
        },
      },
    },
    watch: {
      order () {
        this.$emit('searchOrderBy', this.order)
      },
    },
    methods: {
      toggleSidebar () {
        this.$emit('toggleSidebar')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/StartingBusinessListSortArea.vue